export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "Print",
    variable: "testName",
  },
  {
    name: "QC Name",
    variable: "testType",
  },
  {
    name: "Specimen Type",
    variable: "labId",
  },
  {
    name: "QC Level",
    variable: "resultMethod",
  },
  {
    name: "Lot #",
    variable: "testCode",
  },
  {
    name: "Lot Expiration",
    variable: "orderCode",
  },
];
